import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "w-100 mx-auto d-flex justify-content-center"
}

import { COMBINE_HEADERS } from '@/services/consts/daily_report';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'TableHeader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("thead", null, [
    _createElementVNode("tr", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(COMBINE_HEADERS), (value) => {
        return (_openBlock(), _createElementBlock("th", {
          key: value.key,
          class: _normalizeClass(value.class)
        }, [
          (value.key !== '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(i18n).global.t(`pages.dailyReports.combineForm.list.${value.key}`)), 1))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ])
  ]))
}
}

})